document.addEventListener("DOMContentLoaded", () => {
  window.onload = () => {
    const moreInfoButtons = document.querySelectorAll(".more-button-digest");

    moreInfoButtons.forEach((button) => {
      let parentTextContainer = button
        .closest(".digest__block-container")
        .querySelector(".text-container");
      let parentText = parentTextContainer.querySelector("p");

      if (parentText.scrollHeight > parentText.clientHeight) {
        button.style.display = "inline";
      } else {
        button.style.display = "none";
      }

      button.addEventListener("click", () => {
        parentTextContainer.classList.toggle("active");
        if (parentTextContainer.classList.contains("active")) {
          button.textContent = "скрыть";
          button.style.display = "none";
        } else {
          button.textContent = "подробнее";
        }
      });
    });
  };
});
